import React, { useEffect, Fragment, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Col, Row, Button, FormGroup, Form } from 'reactstrap';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useAuth } from '../../Context/Auth/AuthContext';
import InputMask from 'react-input-mask';
import UserStatuses from '../../enums/UserStatuses';

// const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const schema = Yup.object().shape({
    email: Yup.string().email('Email invalid!').required('Email is required!'),
    name: Yup.string().required('Name is required!'),
    // phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
    password: Yup.string()
        .required('Password is required!')
        .min(6, 'Password must be at least 6 characters'),
    passwordrep: Yup.string()
        .required('Confirm password is required!')
        .oneOf([Yup.ref('password'), null], 'Passwords must match'),
});

const strongSchema = Yup.object().shape({
    email: Yup.string().email('Email invalid!').required('Email is required!'),
    name: Yup.string().required('Name is required!'),
    // phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
    password: Yup.string()
        .required('Please Enter your password')
        .matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
            "Must contain at least: 8 characters, one uppercase, one lowercase, one number and one special symbol"
        ),
    passwordrep: Yup.string()
        .required('Confirm password is required!')
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
});

export default function Invite(props) {
    const history = useHistory();

    // Strong password Schema selection
    const strongPassword = process.env.REACT_APP_STRONG_PASSWORD;
    var schemaToUse = schema;
    if (strongPassword === "true") {
        schemaToUse = strongSchema;
    }

    const { register, handleSubmit, errors, setValue } = useForm({
        validationSchema: schemaToUse,
    });

    const [invite, setInvite] = useState({});
    const { toggleLoading } = useAuth();
    const { match } = props;
    const [groupTitle, setGroupTitle] = useState(null);
    const [defaultPhone, setDefaultPhone] = useState('');

    const { logout } = useAuth();

    const handleLogout = useCallback(async () => {
        await logout();
        history.push('/');
    }, [logout, history]);

    const sanitizePhone = useCallback((phone) => {
        phone = String(phone);
        phone = phone.replace(' ', '');
        phone = phone.replace('(', '');
        phone = phone.replace(')', '');
        phone = phone.replace('-', '');
        return phone;
    }, []);

    useEffect(() => {
        logout();
        api.get(`/ro.team.invite/${match.params.token}`)
            .then((response) => {
                setValue('email', response.data.user.email);
                setDefaultPhone(sanitizePhone(response.data.user.phone));
                setValue('name', response.data.user.name);
                setValue('role', response.data.role.code);
                setInvite(response.data);
                setGroupTitle(response.data.group.title);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    }, [match.params.token, setValue, logout, setDefaultPhone, sanitizePhone]);

    const onSubmitAccept = useCallback(
        async (data) => {
            toggleLoading(true);
            await api
                .post(`/ro.team.acceptInvite/${match.params.token}`, data)
                .then((response) => {
                    handleLogout();
                    toast.success(
                        'Your invitation has been confirmed. Enjoy it!'
                    );
                })
                .catch((err) => {
                    toast.error(err.response.data.message);
                })
                .finally(() => {
                    toggleLoading(false);
                });
        },
        [handleLogout, match.params.token, toggleLoading]
    );

    const onSubmitAcceptUserRegistered = useCallback(async () => {

        toggleLoading(true);
        await api
            .post(`/ro.team.acceptInvite/${match.params.token}`)
            .then((response) => {
                // history.push('/groups');
                handleLogout();
                toast.success('Your invitation has been confirmed. Enjoy it!');
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [handleLogout, match.params.token, toggleLoading]);

    const onSubmitRefuse = useCallback(async () => {
        toggleLoading(true);
        await api
            .get(`/ro.team.refuseInvite/${match.params.token}`)
            .then((response) => {
                handleLogout();
                toast.info('Your invitation has been declined.');
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            })
            .finally(() => {
                toggleLoading(false);
            });
    }, [handleLogout, match.params.token, toggleLoading]);

    return (
        <Fragment>
            <div className="h-100 bg-animation">
                <div className="d-flex h-100 justify-content-center align-items-center">
                    <Col md="8" className="mx-auto app-login-box">
                        <div className="modal-dialog w-100">
                            <div className="modal-content">
                                {invite.userInGroupStatus === UserStatuses.DELETED && (
                                    <Fragment>
                                        <div className="modal-body">
                                            <div className="h5 modal-title text-center">
                                                <h4 className="mt-2">
                                                    <div>Welcome to Senior Link</div>
                                                    <p><span>Seniors Living In Neighborhood Kindness</span></p>
                                                    <p><span>I'm sorry, this invite is Invalid!</span></p>
                                                </h4>
                                            </div>
                                        </div>
                                    </Fragment>
                                )}
                                {invite.userInGroupStatus !== UserStatuses.DELETED && (
                                    <Fragment>
                                        <div className="modal-body">
                                            <div className="h5 modal-title text-center">
                                                <h4 className="mt-2">
                                                    <div>Welcome to Senior Link</div>
                                                        <p><span>Seniors Living In Neighborhood Kindness</span></p>

                                                        {groupTitle && (
                                                        <p><span>You were invited to join: "{groupTitle}"</span></p>
                                                    )}
                                                </h4>
                                            </div>
                                            {!invite.userRegistered && (
                                                <Form>
                                                    <Row className="divider" />
                                                    <Row form>
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <input
                                                                    type="email"
                                                                    name="email"
                                                                    id="exampleEmail"
                                                                    placeholder="Email"
                                                                    ref={register}
                                                                    className="form-control"
                                                                    disabled={true}
                                                                />
                                                                {errors.email && (
                                                                    <p className="error-validation">
                                                                        {
                                                                            errors.email
                                                                                .message
                                                                        }
                                                                    </p>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <input
                                                                    type="text"
                                                                    name="name"
                                                                    id="exampleName"
                                                                    placeholder="Name"
                                                                    ref={register}
                                                                    className="form-control"
                                                                />
                                                                {errors.name && (
                                                                    <p className="error-validation">
                                                                        {
                                                                            errors.name
                                                                                .message
                                                                        }
                                                                    </p>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                {/* <input
                                                                    type="text"
                                                                    name="phone"
                                                                    id="examplePhone"
                                                                    placeholder="Phone"
                                                                    ref={register}
                                                                    className="form-control"
                                                                /> */}
                                                                <InputMask
                                                                    mask="(999) 999-9999"
                                                                    type="text"
                                                                    name="phone"
                                                                    id="examplePhone"
                                                                    placeholder="Phone"
                                                                    inputRef={register}
                                                                    className="form-control"
                                                                    value={defaultPhone}
                                                                />
                                                                {errors.phone && (
                                                                    <p className="error-validation">
                                                                        {
                                                                            errors.phone
                                                                                .message
                                                                        }
                                                                    </p>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <input
                                                                    type="password"
                                                                    name="password"
                                                                    id="examplePassword"
                                                                    placeholder="Password"
                                                                    ref={register}
                                                                    className="form-control input-highlight"
                                                                />
                                                                {errors.password && (
                                                                    <p className="error-validation">
                                                                        {
                                                                            errors
                                                                                .password
                                                                                .message
                                                                        }
                                                                    </p>
                                                                )}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md={12}>
                                                            <FormGroup>
                                                                <input
                                                                    type="password"
                                                                    name="passwordrep"
                                                                    id="examplePasswordRep"
                                                                    placeholder="Repeat Password"
                                                                    ref={register}
                                                                    className="form-control input-highlight"
                                                                />
                                                                {errors.passwordrep && (
                                                                    <p className="error-validation">
                                                                        {
                                                                            errors
                                                                                .passwordrep
                                                                                .message
                                                                        }
                                                                    </p>
                                                                )}
                                                            </FormGroup>
                                                            <FormGroup>
                                                                <select
                                                                    name="role"
                                                                    id="role"
                                                                    className="form-control"
                                                                    ref={register}
                                                                    disabled={true}
                                                                >
                                                                    <option value="">Group role</option>
                                                                    <option value="1">As: Coordinator</option>
                                                                    <option value="2">As: Volunteer</option>
                                                                    <option value="3">As: Senior</option>
                                                                </select>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            )}
                                        </div>
                                        <div className="modal-footer d-block text-center">
                                            <Button
                                                color="danger"
                                                className="btn-wide btn-pill btn-shadow btn-hover-shine mb-2 mr-2"
                                                size="lg"
                                                onClick={onSubmitRefuse}
                                            >
                                                Decline
                                            </Button>
                                            {!invite.userRegistered ? (
                                                <Button
                                                    color="primary"
                                                    className="btn-wide btn-pill btn-shadow btn-hover-shine mb-2 mr-2"
                                                    size="lg"
                                                    onClick={handleSubmit(
                                                        onSubmitAccept
                                                    )}
                                                >
                                                    Confirm
                                                </Button>
                                            ) : (
                                                <Button
                                                    color="primary"
                                                    className="btn-wide btn-pill btn-shadow btn-hover-shine mb-2 mr-2"
                                                    size="lg"
                                                    onClick={
                                                        onSubmitAcceptUserRegistered
                                                    }
                                                >
                                                    Confirm
                                                </Button>
                                            )}
                                        </div>
                                    </Fragment>
                                )}
                            </div>
                        </div>
                        {/* <div className="text-center text-white opacity-8 mt-3">
                            Copyright &copy; ArchitectUI 2019
                        </div> */}
                    </Col>
                </div>
            </div>
        </Fragment>
    );
}
